import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Router } from '@angular/router';

import { BehaviorSubject } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { EMPTY } from 'rxjs';
import { environment } from '../../environments/environment';



@Injectable()
export class RequestService {
  /* URLS DE PROD */
  urlSSO = environment.urlSSO;
  urlTO = environment.urlTO;
  urlPerformance = environment.urlPerformance;
  private userInfo: any;

  constructor(private http: HttpClient,
              private router: Router ) { }

  getUserInfo() {
    if (!this.userInfo) {
      const storedUserInfo = sessionStorage.getItem('userInfo');
      if (storedUserInfo) {
        try {
          this.userInfo = JSON.parse(storedUserInfo);
        } catch (error) {
          this.userInfo = null;
        }
      }
    }
    return this.userInfo;
  }

  setUserInfo(user: any) {
    this.userInfo = user;
    sessionStorage.setItem('userInfo', JSON.stringify(user));
  }

  isLogin() {
    console.log("")
  }

  noTokenRequest(request: any, method: string) {
      const body = JSON.stringify(request);
      const headers = new HttpHeaders({
        'Content-Type': 'application/json'
      });
      return this.http.post(`${this.urlSSO}${method}`, body, { headers })
      .pipe(
        map((response: any) => {
          if (response.status.toUpperCase() !== 'OK') {
            throw response.result;
          }
          return response.result[0];
        })
      );
  }

  // Recovery request
  RecoveryRequest(request: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      const body = JSON.stringify(request);
      const headers = new HttpHeaders({
        'Content-Type': 'application/json',

      });
      this.http.post(`${this.urlTO}RecoveryRequest`, body, { headers }).pipe(
        // Capturamos los errores del servicio
        catchError(err => {
          reject('Service error');
          return EMPTY;
        }),
        // Mapeamos la respuesta
        map(response => {
          return response;
        })
      ).subscribe(response => {
        resolve(response);
      });
    });
  }


  noTokenRequestPruebas(request: any, method: string): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      const body = JSON.stringify(request);
      const headers = new HttpHeaders({
        'Content-Type': 'application/json',

      });
      console.log('Method', method)
      console.log('REQUEST', request);
      this.http.post(`${this.urlSSO}${method}`, body, { headers }).pipe(
        // Capturamos los errores del servicio
        catchError(err => {
          reject('Service error');
          return EMPTY;
        }),
        // Mapeamos la respuesta
        map(response => {
          return response;
        })
      ).subscribe(response => {

        resolve(response);

      });
    });
  }

  tokenVerification(request: any, method: string): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      const body = JSON.stringify(request);
      const headers = new HttpHeaders({
        'Content-Type': 'application/json',

      });
      console.log('Method', method)
      console.log('REQUEST', request);
      this.http.post(`${this.urlTO}${method}`, body, { headers }).pipe(
        // Capturamos los errores del servicio
        catchError(err => {
          reject('Service error');
          return EMPTY;
        }),
        // Mapeamos la respuesta
        map(response => {
          return response;
        })
      ).subscribe(response => {

        resolve(response);

      });
    });
  }


  noTokenRequestOld(request: any, method: string): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      const body = JSON.stringify(request);
      const headers = new HttpHeaders({
        'Content-Type': 'application/json',
        'Empresa': 'NN'
      });
      console.log("Method", method)
      this.http.post(`${this.urlTO}${method}`, body, { headers }).pipe(
        // Capturamos los errores del servicio
        catchError(err => {
          reject('Service error');
          return EMPTY;
        }),
        // Mapeamos la respuesta
        map(response => {
          return response['result'];
        })
      ).subscribe(response => {
        // Valida el estado del resultado
        if (response['resultStatus'].toLowerCase() === 'ok') {
          resolve(response['resultObject']);
        } else {
          reject(`${response['resultObject']}`);
        }
      });
    });
  }


  request(request: any, method: string): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      const body = JSON.stringify(request);
      const headers = new HttpHeaders({
        'Content-Type': 'application/json',
        'Token': sessionStorage.getItem('token'),
        // 'Token': 'fail-token',
        'Empresa': sessionStorage.getItem('company') ? sessionStorage.getItem('company') : sessionStorage.getItem('user')
      });
      /* console.log('request', request, method); */
      this.http.post(`${this.urlTO}${method}`, body, { headers }).pipe(
        // Capturamos los errores del servicio
        catchError(err => {
          if (err.status === 401) {
            this.router.navigate(['/login']);
          } else {
            reject('Service error');
          }
          return EMPTY;
        }),
        // Mapeamos la respuesta
        map(response => {
          return response['result'];
        })
      ).subscribe(response => {
        // Valida el estado del resultado
        if (response['resultStatus'].toLowerCase() === 'ok') {
          resolve(response['resultObject']);
        } else {
          console.log('err', response);
          if (request['table'] === 'test') {
            reject(response);
          }
          reject(response['resultObject']);
        }
      });
    });
  }

  changeLang(val) {
    let urlFile = '';
    if (val === 'en') {
      urlFile = 'assets/textos_sso_en.json';
    } else if (val === 'es') {
      urlFile = 'assets/textos_sso_es.json';
    }
    return this.http.get(urlFile);
  }


}
